/* External Packages */
import './scripts/jqueryLib';

/* Internal Files */
// TODO: Organize your imports
import general from './scripts/general.js';
import navigation from './scripts/navigation.js';
import blocks from './blocks/blocks.js';
import handleDropdownToggle from './blocks/state-dropdown';
import dynamicText from './components/text.js';
import shoppingCart from './scripts/shoppingCart';
import domainFooter from './scripts/domainFooter';
import handleDomainSearchForm from './blocks/domain-search.js';
import handleBackToTop from './blocks/back-top-button';
import { handleReportingIndexSort, toggleNavTabs, setupMonthYearDropdowns } from './blocks/reporting-index-table';
import { setupRangeChartUI } from './components/reporting-table-graph';
import {setupCustomerInsightsMap, setupCustomerInsightsDatePicker} from './components/customer-insight-biz-reporting.js';


/* loader.js is bundled separately via Webpack. Do not import it here! */
/* lighthouse.js is bundled separately via Webpack. Do not import it here! */
document.addEventListener('DOMContentLoaded', function () {
    general();
    navigation();
    blocks();
    handleDropdownToggle();
    dynamicText();
    shoppingCart();
    domainFooter();
    handleDomainSearchForm();
    handleBackToTop();

    // Business reporting index table logic
    handleReportingIndexSort();
    toggleNavTabs();
    setupMonthYearDropdowns();
    setupRangeChartUI();
    setupCustomerInsightsMap();
    setupCustomerInsightsDatePicker();
});